<template>
  <!-- A container showing the right component to show -->
  <div id="ObjectDiv">
    <!-- Show the component indicated by the current route -->
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" v-bind:selectedLang="selectedLang" :key="$route.name" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>

export default {
  name: 'PageObject',
  components: {
  },
  props:{
    selectedLang : String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#ObjectDiv {
  width: 83vw;
  height : 100%;
  min-height: 84vh;
  padding-top: 2vh;
  margin-left: auto;
}

@media screen and (max-width: 850px) {
  #ObjectDiv {
    width: 100%;
  }
}

</style>
